import confetti from "canvas-confetti";
import { toast } from "sonner";

const STORAGE_KEY = "tf_achievements_seen";

function readSeen() {
  try {
    return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"));
  } catch { return new Set(); }
}

function writeSeen(set) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(set))); }
  catch { /* ignore */ }
}

/**
 * Given the full list of badges from ClientDashboard, celebrate any that were
 * just unlocked (weren't in localStorage before). Runs a confetti burst + toast.
 */
export function celebrateNewlyUnlocked(badges) {
  if (!badges || badges.length === 0) return;
  const seen = readSeen();
  const fresh = badges.filter((b) => b.unlocked && !seen.has(b.key));
  if (fresh.length === 0) {
    // Persist all currently unlocked keys so future sessions don't retrigger
    badges.filter((b) => b.unlocked).forEach((b) => seen.add(b.key));
    writeSeen(seen);
    return;
  }

  // Delay slightly so it lands after the dashboard finishes painting
  setTimeout(() => {
    fireConfetti();
    fresh.forEach((b, i) => {
      setTimeout(() => {
        toast.success(`🎉 Traguardo sbloccato: ${b.title}`, {
          description: b.subtitle,
          duration: 5000,
        });
      }, i * 600);
    });
    fresh.forEach((b) => seen.add(b.key));
    // Also mark all currently unlocked as seen (so the counter is stable)
    badges.filter((b) => b.unlocked).forEach((b) => seen.add(b.key));
    writeSeen(seen);
  }, 400);
}

function fireConfetti() {
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999, colors: ["#CCF22C", "#193529", "#D4A017", "#4A8A3E"] };
  const shoot = (particleRatio, opts) => {
    confetti({ ...defaults, ...opts, particleCount: Math.floor(200 * particleRatio) });
  };
  shoot(0.25, { spread: 26, startVelocity: 55, origin: { y: 0.7 } });
  shoot(0.2,  { spread: 60, origin: { y: 0.7 } });
  shoot(0.35, { spread: 100, decay: 0.91, scalar: 0.9, origin: { y: 0.7 } });
  shoot(0.1,  { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2, origin: { y: 0.7 } });
}
